export * from './useCreatePartnershipInvite';
export * from './useShowInvitePartner';

export type PartnerSwitcherType = 'MINE' | 'SHARED' | 'THEIRS';
